import CurrencyFormat from 'components/CurrencyFormat';
import { TableWidgetPlaceholderBlock } from 'components/superreports/widgets/table/blocks/TableWidgetPlaceholderBlock';
import Tooltip from 'components/Tooltip';
import React from 'react';
import type { Currency } from 'types/account';
import type { Cost } from 'types/units';
import { formatCurrency } from 'utils/currency';
import styles from './InvoiceCost.module.scss';

interface Props {
  totalCost: Cost;
  externalCost: Cost;
  currencyLookup: Record<string, Currency>;
}

const InvoiceCost: React.FC<Props> = ({ totalCost, externalCost, currencyLookup }) => {
  if (!externalCost.amount || totalCost.amount === externalCost.amount) {
    return (
      <CurrencyFormat
        animated={false}
        value={totalCost.amount}
        zeroPlaceholder={<TableWidgetPlaceholderBlock />}
        currency={currencyLookup[totalCost.currency_code]}
      />
    );
  }

  const currency = currencyLookup[externalCost.currency_code];

  const formattedExternalCost = formatCurrency(currency, externalCost.amount, 0);

  return (
    <Tooltip
      className={styles.externalCost}
      title={`The external total for this invoice has changed, it is now ${formattedExternalCost}`}
    >
      <CurrencyFormat
        animated={false}
        value={totalCost.amount}
        zeroPlaceholder={<TableWidgetPlaceholderBlock />}
        currency={currency}
      />
      *
    </Tooltip>
  );
};

export default InvoiceCost;
